import Clipboard from 'clipboard';
import timeSvc from '../../services/timeSvc';

// Vue 3 directives - export to be registered on app instance
export const focusDirective = {
  mounted(el) {
    el.focus();
    const { value } = el;
    if (value && el.setSelectionRange) {
      el.setSelectionRange(0, value.length);
    }
  },
};

const setVisible = (el, value) => {
  el.style.display = value ? '' : 'none';
  if (value) {
    el.removeAttribute('aria-hidden');
  } else {
    el.setAttribute('aria-hidden', 'true');
  }
};

// Note: 'show' directive removed - use Vue's built-in v-show instead

const setElTitle = (el, title) => {
  el.title = title;
  el.setAttribute('aria-label', title);
};

export const titleDirective = {
  mounted(el, { value }) {
    setElTitle(el, value);
  },
  updated(el, { value, oldValue }) {
    if (value !== oldValue) {
      setElTitle(el, value);
    }
  },
};

// Clipboard directive
const createClipboard = (el, value) => {
  el.seClipboard = new Clipboard(el, { text: () => value });
};
const destroyClipboard = (el) => {
  if (el.seClipboard) {
    el.seClipboard.destroy();
    el.seClipboard = null;
  }
};

export const clipboardDirective = {
  mounted(el, { value }) {
    createClipboard(el, value);
  },
  updated(el, { value, oldValue }) {
    if (value !== oldValue) {
      destroyClipboard(el);
      createClipboard(el, value);
    }
  },
  unmounted(el) {
    destroyClipboard(el);
  },
};

// Format time helper (replaces Vue.filter)
export const formatTime = (time, timeCounter) => timeSvc.format(time, timeCounter);

// Register all directives on app instance
export function registerDirectives(app) {
  app.directive('focus', focusDirective);
  app.directive('title', titleDirective);
  app.directive('clipboard', clipboardDirective);
}

